import { useLicensesReport } from "../LicenseReports/hooks";
import { useTransactionsReports } from "../TransactionsReports/hooks";
import { licenseDetailsConfig } from "./ReportDetailsConfig/LicenseDetailsConfig";
import { transactionDetailsConfig } from "./ReportDetailsConfig/TransactionDetailsConfig";
export const reportNameToLabel = {
  transactions: 'Transaction details',
  licenses: 'License details'
};
export const reportNameToHooks = {
  transactions: useTransactionsReports,
  licenses: useLicensesReport
};
export const reportNameToDetailsConfig = {
  transactions: transactionDetailsConfig,
  licenses: licenseDetailsConfig
};